import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Shows the platform "Made with Emergent" badge ONLY on the public home page ("/").
 * On every other route (dashboard, login, etc.) it is hidden so it never covers
 * important information. The badge itself lives in public/index.html.
 */
export default function EmergentBadgeControl() {
  const { pathname } = useLocation();
  useEffect(() => {
    const badge = document.getElementById("emergent-badge");
    if (!badge) return;
    const showOnHome = pathname === "/";
    badge.style.setProperty("display", showOnHome ? "inline-flex" : "none", "important");
  }, [pathname]);
  return null;
}
